import {EntityCollectionServiceBase, EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AuthService} from '../../auth/api/service/auth.service';
import {Injector} from '@angular/core';
import {tap} from 'rxjs/operators';

export class AbstractService<T> extends EntityCollectionServiceBase<T> {

    private authService: AuthService;

    constructor(entityName: string, serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super(entityName, serviceElementsFactory);

        this.authService = injector.get(AuthService);
        this.authService.tokenChanged$.pipe(tap((tokenChanged) => {
            if (tokenChanged === true) {
                this.clearCache();
            }
        })).subscribe();

    }
}
